/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Hero_Title_MarkedInputs */

const da_forside_hero_title_marked = /** @type {(inputs: Forside_Hero_Title_MarkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hurtigere`)
};

/** @type {(inputs: Forside_Hero_Title_MarkedInputs) => LocalizedString} */
const en_forside_hero_title_marked = da_forside_hero_title_marked;

/**

* @param {Forside_Hero_Title_MarkedInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_hero_title_marked = /** @type {((inputs?: Forside_Hero_Title_MarkedInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Hero_Title_MarkedInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_hero_title_marked(inputs)
	return /** @type {LocalizedString} */ ("hurtigere")
});